var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "wrapper", staticClass: "rb-anchors-bar__wrapper" }, [
    _c("div", {
      ref: "wrapperBarShim",
      class: {
        "rb-anchors-bar__shim": _vm.isSticky,
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "rb-anchors-bar",
        class: _vm.modifierClasses,
        style: _vm.inlineStyle,
      },
      [
        !_vm.isMobile &&
        _vm.widthIsGreaterThanContainer &&
        !_vm.isRightOffsetMin
          ? _c(
              "button",
              {
                staticClass: "rb-anchors-bar__navigation-arrow",
                on: {
                  click: function ($event) {
                    return _vm.scrollToDirection("left")
                  },
                },
              },
              [_c("rb-lazy-icon", { attrs: { icon: _vm.caretLeft } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "anchorsBarContainer",
            staticClass: "rb-anchors-bar__container",
          },
          [_vm._t("default")],
          2
        ),
        _vm._v(" "),
        !_vm.isMobile &&
        _vm.widthIsGreaterThanContainer &&
        !_vm.isRightOffsetMax
          ? _c(
              "button",
              {
                staticClass: "rb-anchors-bar__navigation-arrow",
                on: {
                  click: function ($event) {
                    return _vm.scrollToDirection("right")
                  },
                },
              },
              [_c("rb-lazy-icon", { attrs: { icon: _vm.caretRight } })],
              1
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }